import { useEffect, useMemo, useState } from "react";
import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";
import Formulario from "../../Componentes/Utils/Formulario";
import FormComp from "../../Componentes/FormComp";
import useApi from "../../hooks/useApi";

const FORNECEDORES_ENDPOINT = "/Painel/API/InventarioTI/GetFornecLicenca/";
const CREATE_TIPO_ENDPOINT = "/Painel/API/InventarioTI/CreateTipoLicenca/";

export default function ModalNovoTipoLicenca({ onClose, onCreated, fornecedores, onRequestFornecedores }) {
  const api = useApi();
  const [saving, setSaving] = useState(false);
  const [loadingFornecedores, setLoadingFornecedores] = useState(false);
  const [listaFornecedores, setListaFornecedores] = useState(fornecedores ?? []);
  const [form, setForm] = useState({
    id_fornec: "",
    descricao: "",
  });

  useEffect(() => {
    if (Array.isArray(fornecedores) && fornecedores.length > 0) {
      setListaFornecedores(fornecedores);
      return;
    }

    const carregarFornecedores = async () => {
      setLoadingFornecedores(true);
      try {
        const { data } = await api.get(FORNECEDORES_ENDPOINT);
        const list = Array.isArray(data) ? data : data?.data ?? [];
        setListaFornecedores(Array.isArray(list) ? list : []);
      } catch (err) {
        console.error(err);
        alert(err?.response?.data?.message || "Erro ao carregar fornecedores.");
      } finally {
        setLoadingFornecedores(false);
      }
    };

    carregarFornecedores();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fornecedores]);

  const canSubmit = useMemo(() => {
    return Boolean(String(form.id_fornec || "").trim()) && Boolean(form.descricao.trim());
  }, [form.descricao, form.id_fornec]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => {
      if (name === "id_fornec") {
        return { ...prev, id_fornec: value };
      }
      return { ...prev, [name]: value.toUpperCase() };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;

    try {
      setSaving(true);

      await api.post(CREATE_TIPO_ENDPOINT, {
        id_fornec: Number(form.id_fornec),
        descricao: form.descricao.trim().toUpperCase(),
      });

      onClose?.();
      onCreated?.();
      onRequestFornecedores?.();
    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.message || "Erro ao cadastrar tipo de licença.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Overlay state={true}>
      <Modal header close={onClose} size="sm">
        <Formulario onSubmit={handleSubmit}>
          <FormComp
            title="FORNECEDOR"
            type="select"
            options={(listaFornecedores ?? []).map((f) => ({
              value: String(f.id),
              label: f.descricao,
            }))}
            obj
            valor={String(form.id_fornec || "")}
            name="id_fornec"
            changeFunc={handleChange}
            disabled={loadingFornecedores || listaFornecedores.length === 0}
            required
          />
          <FormComp
            title="TIPO DE LICENÇA"
            type="text"
            placeholder="EX: MICROSOFT 365 E3"
            valor={form.descricao}
            name="descricao"
            changeFunc={handleChange}
            required
          />
          <FormComp
            type="submit"
            valor={saving ? "SALVANDO..." : "SALVAR"}
            disabled={saving || !canSubmit || loadingFornecedores || listaFornecedores.length === 0}
          />
        </Formulario>
      </Modal>
    </Overlay>
  );
}
